<template>
  <a role="button" href="/" class="lettertype" title="감영길예술가의 거리">
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="105.7px"
      height="15.3px"
      viewBox="0 0 105.7 15.3"
      style="overflow:visible;enable-background:new 0 0 105.7 15.3;"
      xml:space="preserve"
    >
      <g>
        <path
          class="st0"
          d="M45.9,15.3h1.4l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4H48h0h1.4h0h1.4v0h0
		c0,0,0,0,0,0h0v0c0.4,0,0.7-0.1,1.1-0.2c0.3-0.1,0.6-0.3,0.9-0.6c0,0,0.1-0.1,0.1-0.1c0,0,0.1,0.1,0.1,0.1c0.3,0.3,0.6,0.5,0.9,0.6
		c0.3,0.1,0.7,0.2,1.1,0.2v0h0c0,0,0,0,0,0h0h0h0v0h1.4h0h1.4l0-1.4l-1.4,0v0l-1.4,0c-0.8,0-1.4-0.6-1.4-1.4c0,0,0,0,0,0v0v0v0h0v0
		l-1.4,0h0v0c0,0.8-0.6,1.4-1.4,1.4l-1.4,0v0l-1.4,0v0l-0.7,0l0-1.4l-1.4,0l0,1.4h0l0,1.4h0l0,1.4h0l0,1.4h0l0,1.4h0l0,1.4h0l0,1.4
		h0l0,1.4h0l0,1.4h0l0,1.4h0L45.9,15.3z"
        />
        <path
          class="st0"
          d="M36.1,8.4L36.1,8.4c0,0.4,0.1,0.7,0.2,1.1c0.1,0.3,0.3,0.6,0.6,0.9c0.3,0.3,0.6,0.5,0.9,0.6
		c0.3,0.1,0.7,0.2,1.1,0.2v0h0c0,0,0,0,0,0h0h0v0c0.4,0,0.7-0.1,1.1-0.2c0.3-0.1,0.6-0.3,0.9-0.6c0.3-0.3,0.5-0.6,0.6-0.9
		c0.1-0.3,0.2-0.7,0.2-1.1h0l0-1.4h0l0-1.4c0.7,0,1.4,0.6,1.4,1.4v0v0h0l0,1.4h0l0,1.4h0l0,1.4h0l0,1.4h0l0,1.4h0l0,1.4h1.4l0-1.4h0
		l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4h0v0c0,0,0,0,0,0v0h0c0-0.4-0.1-0.7-0.2-1.1
		c-0.1-0.3-0.3-0.6-0.6-0.9c-0.3-0.3-0.6-0.5-0.9-0.6C42.6,0.1,42.3,0,42,0c0,0,0,0,0,0c-0.1,0-0.2,0-0.3,0v0l-1.4,0v0L39,0v0h0
		c0,0,0,0,0,0h0h0v0c-0.4,0-0.7,0.1-1.1,0.2c-0.3,0.1-0.6,0.3-0.9,0.6c-0.3,0.3-0.5,0.6-0.6,0.9c-0.1,0.3-0.2,0.7-0.2,1.1h0l0,1.4h0
		l0,1.4h0l0,1.4h0L36.1,8.4L36.1,8.4L36.1,8.4C36.1,8.4,36.1,8.4,36.1,8.4L36.1,8.4z M43.1,4.5c-0.1-0.1-0.2-0.1-0.3-0.1
		c-0.3-0.1-0.5-0.2-0.8-0.2c0,0,0,0,0,0c-0.1,0-0.2,0-0.3,0l0-1.4h0v0c0,0,0,0,0,0v0h0c0-0.4-0.1-0.7-0.2-1.1c0-0.1-0.1-0.2-0.1-0.3
		h0.3v0h0c0.8,0,1.4,0.6,1.4,1.4l0,1.4h0L43.1,4.5z M37.6,5.6L37.6,5.6V4.2h0l0-1.4h0v0c0-0.8,0.6-1.4,1.4-1.4h0
		c0.8,0,1.4,0.6,1.4,1.4l0,1.4h0l0,1.4h0l0,1.4h0l0,1.4h0v0c0,0.8-0.6,1.4-1.4,1.4h0c-0.8,0-1.4-0.6-1.4-1.4l0-1.4h0L37.6,5.6z"
        />
        <path
          class="st0"
          d="M63.9,15.3h1.4l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4h0v0
		c0-0.8,0.6-1.4,1.4-1.4h1.4h0h1.4h0h1.4h0h1c-0.1,0.1-0.1,0.2-0.1,0.3c-0.1,0.3-0.2,0.7-0.2,1.1h0l0,1.4h0l0,1.4h0v0c0,0,0,0,0,0v0
		h0c0,0.4,0.1,0.7,0.2,1.1C72,7,72.2,7.3,72.4,7.6C72.7,7.8,73,8,73.3,8.2c0.3,0.1,0.7,0.2,1.1,0.2v0h0c0,0,0,0,0,0h0h0v0
		c0.4,0,0.7-0.1,1.1-0.2c0.3-0.1,0.6-0.3,0.9-0.6C76.6,7.3,76.8,7,77,6.7c0.1-0.3,0.2-0.7,0.2-1.1h0l0-1.4h0l0-1.4h0v0c0,0,0,0,0,0
		v0h0c0-0.4-0.1-0.7-0.2-1.1c-0.1-0.3-0.3-0.6-0.6-0.9c-0.3-0.3-0.6-0.5-0.9-0.6C75.1,0.1,74.8,0,74.4,0v0h0v0l-0.7,0v0l-1.4,0v0
		l-1.4,0v0l-1.4,0v0l-1.4,0v0l-1.4,0v0h0c0,0,0,0,0,0h0v0c-0.4,0-0.7,0.1-1.1,0.2c-0.3,0.1-0.6,0.3-0.9,0.6
		c-0.3,0.3-0.5,0.6-0.6,0.9C64,2.1,64,2.4,63.9,2.8h0l0,1.4h0l0,1.4h0l0,1.4h0l0,1.4h0l0,1.4h0l0,1.4h0l0,1.4h0l0,1.4h0L63.9,15.3z
		 M74.4,7C73.6,7,73,6.3,73,5.6l0-1.4h0l0-1.4h0v0c0-0.8,0.6-1.4,1.4-1.4h0c0.8,0,1.4,0.6,1.4,1.4l0,1.4h0l0,1.4h0v0
		C75.8,6.3,75.2,6.9,74.4,7L74.4,7z"
        />
        <path
          class="st0"
          d="M76.5,9.7L76.5,9.7h-1.4v0l-1.4,0v0l-1.4,0v0l-1.4,0v0l-1.4,0l0,1.4h1.4h0h1.4h0h1.4h0h1.4h0h1.4h0h1.4v0h0
		c0,0,0,0,0,0h0v0c0.4,0,0.7-0.1,1.1-0.2c0.1,0,0.2-0.1,0.3-0.1l0,0.3h0l0,1.4h0l0,1.4h0l0,1.4h1.4l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4h0
		l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4l-1.4,0l0,1.4h0l0,1.4h0l0,1.4h0l0,1.4h0l0,1.4h0l0,1.4h0v0h0v0
		c0,0.8-0.6,1.4-1.4,1.4L76.5,9.7z"
        />
        <path
          class="st0"
          d="M57,4.2l-1.4,0v0l-1.4,0v0l-1.4,0v0l-1.4,0v0l-1.4,0v0l-1.4,0v0l-0.7,0l0,1.4h0.7h0H50h0h1.4h0h0.7l0,1.4
		l-1.4,0v0l-1.4,0v0L48,7l0,1.4h1.4h0h1.4h0h1.4h0h1.4h0h0.7H55h0.7v0h0C56.4,8.4,57,9,57,9.7v0c0,0.7-0.6,1.4-1.4,1.4v0l-1.4,0v0
		l-0.7,0v0l-1.4,0v0l-1.4,0v0l-1.4,0v0l-1.4,0l0,1.4h0l0,1.4h0l0,1.4h1.4h0h1.4h0h1.4h0h1.4h0h1.4h0h1.4h0h1.4h0h0.7l0-1.4l-0.7,0v0
		l-1.4,0v0l-1.4,0v0l-1.4,0v0l-1.4,0v0l-1.4,0v0l-1.4,0l0-1.4h0h1.4h0h1.4h0h0.7h0.7h0.7h0h1.4v0h0c0.4,0,0.7-0.1,1.1-0.2
		c0.3-0.1,0.6-0.3,0.9-0.6c0.3-0.3,0.5-0.6,0.6-0.9c0.1-0.3,0.2-0.7,0.2-1.1h0v0c0,0,0,0,0,0v0v0h0c0-0.4-0.1-0.7-0.2-1.1
		c-0.1-0.3-0.3-0.6-0.6-0.9c-0.3-0.3-0.6-0.5-0.9-0.6C56.5,7.1,56.2,7,55.9,7c0,0,0,0,0,0c-0.1,0-0.2,0-0.3,0v0L55,7v0l-1.4,0v0h0
		l0-1.4h0.7h0h1.4h0H57v0c0.4,0,0.7-0.1,1.1-0.2C58.4,5.2,58.7,5,59,4.8c0.3-0.3,0.5-0.6,0.6-0.9c0.1-0.3,0.2-0.7,0.2-1.1h0v0
		c0,0,0,0,0,0c0,0,0,0,0,0v0v0v0h0l0-1.4c0.7,0,1.3,0.6,1.4,1.4l0,1.4h0l0,1.4h0l0,1.4h0l0,1.4h0l0,1.4h0l0,1.4h1.4l0-1.4h0l0-1.4h0
		l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4h0v0c0,0,0,0,0,0v0h0c0-0.4-0.1-0.7-0.2-1.1c-0.1-0.3-0.3-0.6-0.6-0.9c-0.3-0.3-0.6-0.5-0.9-0.6
		C60.6,0.1,60.4,0,60.1,0c0,0,0,0,0,0c-0.1,0-0.2,0-0.3,0v0l-1.4,0l0,1.4h0l0,1.4C58.4,3.6,57.8,4.2,57,4.2z"
        />
        <path
          class="st0"
          d="M27.8,7L27.8,7h-1.4v0l-1.4,0v0l-1.4,0l0,1.4H25h0h1.4h0h1.4h0h1.4h0h1.4v0h0C31.4,8.4,32,9,32,9.7v0
		c0,0.7-0.6,1.4-1.4,1.4v0l-1.4,0v0l-1.4,0v0l-1.4,0v0l-1.4,0v0l-1.4,0l0,1.4h0l0,1.4h0l0,1.4H25h0h1.4h0h1.4h0h1.4h0h1.4h0H32h0
		h1.4l0-1.4l-1.4,0v0l-1.4,0v0l-1.4,0v0l-1.4,0v0l-1.4,0v0l-1.4,0l0-1.4h0h1.4h0h1.4h0h1.4h0h1.4v0h0c0.4,0,0.7-0.1,1.1-0.2
		c0.3-0.1,0.6-0.3,0.9-0.6c0.3-0.3,0.5-0.6,0.6-0.9c0.1-0.3,0.2-0.7,0.2-1.1h0l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4h0
		l0-1.4L32,0l0,1.4h0l0,1.4h0l0,1.4h0l0,1.4h0L32,7h0l0,0.4c-0.1-0.1-0.2-0.1-0.3-0.1C31.4,7.1,31.2,7,30.9,7c0,0,0,0,0,0
		c-0.1,0-0.2,0-0.3,0v0l-1.4,0v0L27.8,7z"
        />
        <path
          class="st0"
          d="M1.4,1.4L1.4,1.4L1.4,1.4c0.8,0,1.4,0.6,1.4,1.4l0,1.4h0l0,1.4h1.4l0-1.4h0l0-1.4h0C4.2,2.4,4.1,2,4,1.7
		C3.8,1.4,3.6,1.1,3.4,0.8C3.1,0.6,2.8,0.4,2.5,0.2C2.2,0.1,2,0,1.7,0c0,0,0,0,0,0C1.6,0,1.5,0,1.4,0v0L0,0l0,1.4H1.4z"
        />
        <path
          class="st0"
          d="M5.6,7L4.2,7v0L2.8,7v0L1.4,7l0,1.4h0l0,1.4h0l0,1.4h0l0,1.4h0l0,1.4h0l0,1.4h1.4h0h1.4h0h1.4h0H7h0h1.4l0-1.4
		h0l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4L7,7v0h0l0-1.4h0l0-1.4h0l0-1.4h0v0C7,2,7.6,1.4,8.4,1.4h1.4h0h1.4h0h0.3
		c-0.1,0.1-0.1,0.2-0.1,0.3c-0.1,0.3-0.2,0.7-0.2,1.1h0l0,1.4h0l0,1.4h0l0,1.4h0l0,1.4h0v0c0,0,0,0,0,0v0h0c0,0.4,0.1,0.7,0.2,1.1
		c0.1,0.3,0.3,0.6,0.6,0.9c0.3,0.3,0.6,0.5,0.9,0.6c0.3,0.1,0.7,0.2,1.1,0.2v0h0c0,0,0,0,0,0h0h0v0c0.4,0,0.7-0.1,1.1-0.2
		c0.3-0.1,0.6-0.3,0.9-0.6c0.3-0.3,0.5-0.6,0.6-0.9c0.1-0.3,0.2-0.7,0.2-1.1h0l0-1.4h0l0-1.4h1.4h0h1.4v0h0c0.8,0,1.4,0.6,1.4,1.4
		l0,0.3c-0.1-0.1-0.2-0.1-0.3-0.1C20.3,7.1,20,7,19.8,7c0,0,0,0,0,0c-0.1,0-0.2,0-0.3,0v0h0c0,0,0,0,0,0h0h0v0
		c-0.4,0-0.7,0.1-1.1,0.2c-0.3,0.1-0.6,0.3-0.9,0.6C17.2,8,17,8.3,16.9,8.7c-0.1,0.3-0.2,0.7-0.2,1.1h0v0c0,0,0,0,0,0v0v0v0h0l0,1.4
		h0l0,1.4h0v0c0,0,0,0,0,0v0h0c0,0.4,0.1,0.7,0.2,1.1c0.1,0.3,0.3,0.6,0.6,0.9c0.3,0.3,0.6,0.5,0.9,0.6c0.3,0.1,0.7,0.2,1.1,0.2v0h0
		c0,0,0,0,0,0h0h0v0c0.4,0,0.7-0.1,1.1-0.2c0.3-0.1,0.6-0.3,0.9-0.6c0.3-0.3,0.5-0.6,0.6-0.9c0.1-0.3,0.2-0.7,0.2-1.1h0l0-1.4h0
		l0-1.4h0v0h0l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4h0v0c0,0,0,0,0,0v0h0c0-0.4-0.1-0.7-0.2-1.1c0-0.1-0.1-0.2-0.1-0.3h0.3h0h1.4h0
		H25v0h0c0.8,0,1.4,0.6,1.4,1.4l0,1.4h0l0,1.4h1.4l0-1.4h0l0-1.4h0v0c0,0,0,0,0,0v0h0c0-0.4-0.1-0.7-0.2-1.1
		c-0.1-0.3-0.3-0.6-0.6-0.9c-0.3-0.3-0.6-0.5-0.9-0.6C25.9,0.1,25.6,0,25.3,0c0,0,0,0,0,0c-0.1,0-0.2,0-0.3,0v0l-1.4,0v0l-1.4,0v0
		l-1.4,0v0l-1.4,0v0l-1.4,0v0l-1.4,0v0l-1.4,0v0l-1.4,0v0h0v0l-1.4,0v0l-1.4,0v0L9.8,0v0L8.4,0v0h0c0,0,0,0,0,0h0v0
		C8,0,7.6,0.1,7.3,0.2C6.9,0.4,6.6,0.6,6.4,0.8C6.1,1.1,5.9,1.4,5.8,1.7C5.6,2,5.6,2.4,5.6,2.8h0l0,1.4h0l0,1.4h0L5.6,7z M5.6,13.9
		l-1.4,0v0l-1.4,0l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4h0h1.4h0h1.4h0H7l0,1.4h0l0,1.4h0l0,1.4h0l0,1.4H5.6L5.6,13.9z M19.5,13.9
		L19.5,13.9c-0.8,0-1.4-0.6-1.4-1.4l0-1.4h0l0-1.4c0-0.8,0.6-1.4,1.4-1.4h0c0.8,0,1.4,0.6,1.4,1.4l0,1.4h0l0,1.4h0v0
		C20.9,13.3,20.2,13.9,19.5,13.9z M15.3,8.3L15.3,8.3c0,0.8-0.6,1.4-1.4,1.4h0c-0.8,0-1.4-0.6-1.4-1.4l0-1.4h0l0-1.4h0l0-1.4h0
		l0-1.4h0v0c0-0.8,0.6-1.4,1.4-1.4h0c0.8,0,1.4,0.6,1.4,1.4l0,1.4h0l0,1.4h0l0,1.4h0L15.3,8.3L15.3,8.3z M18.1,4.2l-1.4,0l0-1.4h0v0
		c0,0,0,0,0,0v0h0c0-0.4-0.1-0.7-0.2-1.1c0-0.1-0.1-0.2-0.1-0.3h0.3h0h1.4h0h1.4v0h0c0.8,0,1.4,0.6,1.4,1.4l0,1.4h0l0,0.4
		c-0.1-0.1-0.2-0.1-0.3-0.1c-0.3-0.1-0.5-0.2-0.8-0.2c0,0,0,0,0,0c-0.1,0-0.2,0-0.3,0v0H18.1L18.1,4.2z"
        />
        <path
          class="st0"
          d="M84.8,1.4L84.8,1.4L84.8,1.4c0.8,0,1.4,0.6,1.4,1.4l0,1.4h0l0,1.4h0l0,1.4h0l0,1.4h0l0,1.4h0l0,1.4h1.4l0-1.4
		h0l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4h0v0c0,0,0,0,0,0v0h0c0-0.4-0.1-0.7-0.2-1.1c-0.1-0.3-0.3-0.6-0.6-0.9
		c-0.3-0.3-0.6-0.5-0.9-0.6C85.7,0.1,85.4,0,85.1,0c0,0,0,0,0,0c-0.1,0-0.2,0-0.3,0v0l-1.4,0l0,1.4H84.8z"
        />
        <path
          class="st0"
          d="M90.4,5.6L90.4,5.6h1.4v0h0c0.8,0,1.4,0.6,1.4,1.4l0,1.4h0l0,1.4h0l0,1.4h0l0,1.4h0l0,1.4h0l0,1.4h1.4l0-1.4h0
		l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4h0v0h1.4h0h1.4h0h1.4h0h1.4v0h0c0.8,0,1.4,0.6,1.4,1.4
		l0,1.4h0v0c0,0.7-0.6,1.4-1.4,1.4v0l-1.4,0v0l-1.4,0v0l-0.7,0v0l-1.4,0l0,1.4h0l0,1.4h0l0,1.4h0l0,1.4h1.4h0h0.7h0h1.4h0h1.4h0h1.4
		h0h1.4h0h1.4l0,1.4h0l0,1.4h0l0,1.4h1.4l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4h0l0-1.4
		l-1.4,0l0,1.4h0l0,1.4h0l0,1.4h0l0,1.4h0l0,1.4h0l0,1.4h0l0,1.4l-1.4,0v0l-1.4,0v0l-1.4,0v0l-1.4,0v0l-1.4,0v0l-0.7,0l0-1.4h0
		l0-1.4h0h0.7h0h1.4h0h1.4v0h0c0.4,0,0.7-0.1,1.1-0.2c0.3-0.1,0.6-0.3,0.9-0.6c0.3-0.3,0.5-0.6,0.6-0.9c0.1-0.3,0.2-0.7,0.2-1.1h0
		l0-1.4h0v0c0,0,0,0,0,0v0h0c0-0.4-0.1-0.7-0.2-1.1c-0.1-0.3-0.3-0.6-0.6-0.9c-0.3-0.3-0.6-0.5-0.9-0.6c-0.3-0.1-0.5-0.2-0.8-0.2
		c0,0,0,0,0,0c-0.1,0-0.2,0-0.3,0v0l-1.4,0v0l-1.4,0v0L96,0v0l-1.4,0l0,0l-1.4,0l0,1.4h0l0,1.4h0l0,1.4h0l0,0.4
		c-0.1-0.1-0.2-0.1-0.3-0.1c-0.3-0.1-0.5-0.2-0.8-0.2c0,0,0,0,0,0c-0.1,0-0.2,0-0.3,0v0l-1.4,0v0l-1.4,0l0,1.4H90.4z"
        />
      </g>
    </svg>
  </a>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.st0 {
  fill: #005bac;
}
</style>
